<template>
  <article class="mobile-wrap" :style="{'zoom': zoom}">
    <header class="header flex justify-between">
      <div class="header-left">
        <img src="../../assets/images/logo.png" alt="">
      </div>
      <nav class="header-nav flex items-end">
        <a v-for="(nav, index) of navs" :href="`#page${index + 1}`" :key="index"
          :class="`nav n${index + 1}${index === menuIndex ? ' active' : ''}`">{{ nav.title }}</a>
      </nav>
      <div class="header-right flex justify-between">
        <a href="https://game.naver.com/lounge/samgukji_origin2/home" target="_blank">
          <img class="img1" src="../../assets/images/btn_naverlounge.png" alt="">
        </a>
        <a href="https://www.youtube.com/@samgukjioringin2" target="_blank">
          <img class="img2" src="../../assets/images/btn_youtube.png" alt="">
        </a>
      </div>
    </header>

    <section class="content">
      <!-- page1 -->
      <a name="page1"></a>
      <section class="page page1">
        <a href="javascript:;" @click="statistics('click_origin1_player', '', 'https://www.guru-game.com/origin2/origin1rewards/')"><img class="top-ad" src="../../assets/images/top_ad.png" alt=""></a>
        <a href="https://www.guru-game.com/samgukjiorigin2" target="_blank" class="btn-pre"><span class="light-effect"><i class="effect"></i></span></a>
        <div class="link-box">
          <a href="javascript:;" @click="statistics('go_gp', 'gp', 'https://play.google.com/store/apps/details?id=com.guru.jpsgz.kr')" class="gp"><span
              class="light-effect"><i class="effect"></i></span></a>
          <a href="javascript:;" @click="statistics('go_apple', 'apple', 'https://apps.apple.com/kr/app/id6447394503')" class="app"><span class="light-effect"><i
                class="effect"></i></span></a>
          <a href="javascript:;" @click="statistics('go_onestore', 'onestore', 'https://onesto.re/0000768906')" class="one"><span class="light-effect"><i class="effect"></i></span></a>
          <a href="javascript:;" @click="statistics('go_galaxystore', 'galaxystore', 'https://galaxystore.samsung.com/detail/com.guru.jpsgz.krsamsung')" class="galaxy"><span class="light-effect"><i class="effect"></i></span></a>
        </div>
        <a href="#page2" class="btn-down"></a>
      </section>
      <!-- page2 -->
      <a name="page2"></a>
      <section class="page page5">
        <div class="swiper shopsSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="../../assets/images/slide_01.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/slide_02.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/slide_03.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/slide_04.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/slide_05.png" />
            </div>
          </div>
          <button class="btn-prev"></button>
          <button class="btn-next"></button>
          <div class="pagination"></div>
        </div>
      </section>
    </section>

    <div v-if="showDialog.rules === true" class="popup-box popup-rules">
      <div class="inner">
        <a href="javascript:;" class="btn-close" @click="showDialog.rules = false"></a>
        <div class="rules">
          <h3>이벤트 유의사항</h3>
          <p>&nbsp;</p>
          <p><strong>1. 참여 서버:</strong> S1-S30;</p>
          <p><strong>2. 이벤트 보상:</strong> </p>
          <p>S1-S9: 1등급 한우 세트+커스텀 술잔 세트+커스텀 도장</p>
          <p>S10-S20: 1등급 한우 세트+커스텀 도장</p>
          <p>S21-S30: 1등급 한우 세트</p>
          <p><strong>3. 이벤트 설명:</strong></p>
          <p>각 서버 제4년 겨울 (해당 서버 오픈 16일째) 전공 랭킹 1위 유저님께 위 보상을 지급해 드립니다.</p>
          <p>&nbsp;</p>
          <p>더욱 자세한 이벤트 내용은 공식 라운지에서 확인하시기 바랍니다.</p>
        </div>
      </div>
    </div>

    <div v-if="showDialog.privacy === true" class="popup-box popup-privacy">
      <div class="inner">
        <a href="javascript:;" class="btn-close" @click="showDialog.privacy = false"></a>
        <div class="privacy">
          <h3>개인정보 수집 및 이용 안내</h3>
          <p>&nbsp;</p>
          <p>GURU GAMES CO., LIMITED는 &lt;삼국지 오리진2: 적벽대전&gt; 게임 정보 및 사전예약 이벤트 안내를 위해 다음과 같이 개인정보를 수집 및 이용하고 있습니다.</p>
          <p>귀하는 개인정보 수집 및 이용에 동의하지 않을 수 있으며 거부 시 사전예약 이벤트에 참여하실 수 없습니다.</p>
          <p>※ 개인정보 수집 및 이용 목적 : 사전예약 이벤트 당첨자 안내 및 게임 관련 소식 전달</p>
          <p>※ 수집하는 개인정보 항목 : 휴대폰 번호</p>
          <p>※ 개인정보 보유 및 이용기간 : 수집일로부터 1년 </p>
        </div>
      </div>
    </div>

    <div v-if="showDialog.video === true" class="popup-box popup-videos">
      <div class="inner">
        <a href="javascript:;" class="btn-close" @click="showDialog.video = false"></a>

      </div>
    </div>

    <aside class="aside">
      <a href="javascript:;" class="to-top" @click="backToTop"></a>
    </aside>
  </article>
</template>

<script src="../../../public/assets/swiper-bundle.min.js"></script>

<script>
  import { gameBook, showGameBookCount } from "@/api/api";
  export default {
    name: "mobile",
    data() {
      return {
        sideSwiper: null,
        shopsSwiper: null,
        menuIndex: 0,
        navs: [{
          title: "홈페이지",
        },
        {
          title: "게임 소개",
        }],
        firstClick: true, //第一次关闭预约弹窗
        percent: 0,
        registNumbers: 0,
        hasChecked: false,
        showDialog: {
          login: true,
          success: false,
          rules: false,
          video: false,
          alert: false,
          again: false,
          privacy: false,
          alertMsg: ''
        },
        isBooking: false,
        lotteryActive: 0,
        zoom: 1
      };
    },
    created() {
      fbq('init', '1058047045571878');
      fbq('track', 'PageView');

      ttq.load('CJDE74RC77UDNVGREPM0');
      ttq.page();

      if(this.isIOS()) {
        this.ios = true
      } else {
        this.ios = false
      }
    },
    mounted() {
      this.handleScroll();
      window.addEventListener("scroll", this.handleScroll, true);
      this.swiperFunc();
      this.fitScreen();
    },
    methods: {
      isIOS() {
        const u = navigator.userAgent;
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      },
      statistics(name, label, url, type) {
        gtag('event', name, {'event_label': label});
        // 新开链接跳转
        if (url) {
          window.open(url);
        }
      },
      playVideo() {
        // this.showDialog.video = true
        this.statistics('playvideo', 'playvideo', 'https://youtu.be/ZU5LXNZ42tE')
      },
      fitScreen() {
        let that = this
        let ww = window.innerWidth < 1600 ? window.innerWidth : 1600
        that.zoom = ww/1600;
      },
      handleScroll () {
        let that = this
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        
        const dom = document.querySelectorAll(".page");
        let offsetTop = 0
        for (let i = 0; i < dom.length; i++) {
          offsetTop += dom[i].clientHeight;
          if(i === dom.length - 2){
            const gap = window.innerHeight - dom[dom.length - 1].clientHeight;
            if (scrollTop > (offsetTop - 200 - (gap < 0 ? 0 : gap))* that.zoom) {
              this.menuIndex = dom.length - 1;
            }else{
              this.menuIndex = i
            }
            break;
          }
          if (scrollTop < (offsetTop - 100) * that.zoom) {
            this.menuIndex = i;
            break;
          }
        }
      },
      alert(msg) {
        this.showDialog.alert = true;
        this.showDialog.alertMsg = '';
        this.showDialog.alertMsg = msg;
      },
      backToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
      swiperFunc () {
        this.shopsSwiper = new Swiper('.shopsSwiper', {
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".btn-next",
            prevEl: ".btn-prev",
          },
          pagination: {
            el: ".pagination",
            clickable: true, //允许分页点击跳转
          },
          initialSlide: 1,
          grabCursor: true,
          autoplay : {
            delay:5000
          },
          effect : 'coverflow',
          slidesPerView: 3,
          centeredSlides: true,
          coverflowEffect: {
            rotate: 0,
            stretch: -32,
            depth: 250,
            modifier: 2,
            slideShadows : true
          },
        })

        this.sideSwiper = new Swiper(".sideSwiper", {
          loop: true,
          allowTouchMove: true,
          autoplay : {
            delay: 3000
          },
          speed: 700,
          effect : 'fade',
          fadeEffect: {
            crossFade: true,
          }
        });
      },
    }
  };
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  min-width: 1300px;
  height: 74px;
  background: rgba(0, 0, 0, .85);

  .header-left {
    width: 104px;
    height: 69px;
    margin-left: 37px;
    margin-top: 2px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .header-nav {
    width: 800px;
    margin: 0 auto;

    .nav {
      height: 48px;
      background-size: 100% 100%;
      text-indent: -9999px;
      cursor: pointer;
      &.n1{
        width: 165px;
        background-image: url(../../assets/images/menu_1.png);
        &.active{
          background-image: url(../../assets/images/menu_1_a.png);
        }
      }
      &.n2{
        width: 173px;
        background-image: url(../../assets/images/menu_3.png);
        &.active{
          background-image: url(../../assets/images/menu_3_a.png);
        }
      }
    }
  }


  .header-right {
    width: 104px;
    margin-top: 24px;
    margin-right: 46px;

    img {
      cursor: pointer;
      cursor: hand;
    }

    .img1 {
      width: 40px;
      height: 33px;
    }

    .img2 {
      width: 34px;
      height: 27px;
    }

    .img3 {
      width: 38px;
      height: 29px;
    }
  }
}

.btn-close {
  position: absolute;
  z-index: 1002;
  width: 50px;
  height: 50px;
  background: url(../../assets/images/btn_close.png) no-repeat;

}

.link-box {
  text-align: center;

  a {
    display: inline-block;
    width: 210px;
    height: 60px;
    margin-left: 7px;
    margin-right: 7px;

  }

  .gp {
    background-image: url(../../assets/images/btn_gp.png);
  }

  .app {
    background-image: url(../../assets/images/btn_ios.png);
  }

  .one {
    background-image: url(../../assets/images/btn_one.png);
  }

  .galaxy {
    background-image: url(../../assets/images/btn_galaxy.png);
  }
}

// page1
.page {
  min-width: 1224px;
  height: 1080px;
  background-repeat: no-repeat;
  background-position: center top;
  overflow: hidden;
}

.page1 {
  position: relative;
  background-image: url(../../assets/images/bg1.jpg);

  .top-ad {
    position: absolute;
    left: 44px;
    top: 110px;
    z-index: 1;
    width: 160px;
    height: 160px;
  }

  .btn-video {
    display: block;
    width: 88px;
    height: 88px;
    margin: 636px auto 0;
    background-image: url(../../assets/images/btn_video.png);
  }

  .btn-pre {
    display: block;
    width: 524px;
    height: 146px;
    margin: 700px auto 0;
    background-image: url(../../assets/images/btn_main.png);
    .light-effect {
      width: 365px;
      height: 89px;
      margin-left: 38px;
      margin-top: 38px;
      border-top-left-radius: 50px;
      border-bottom-left-radius: 45px;
      transform:skew(6deg);
    }
  }

  .numbers {
    width: 576px;
    height: 60px;
    margin: -12px auto 0;
    padding-left: 328px;
    background-image: url(../../assets/images/p1_number.png);
    background-position: center;
    background-repeat: no-repeat;

    p {
      width: 154px;
      text-align: center;
      line-height: 60px;
      color: #ffe2aa;
      font-size: 36px;
    }
  }

  .link-box {
    margin-top: 10px;

    .light-effect {
      width: 204px;
      height: 55px;
      margin-left: 3px;
      margin-top: 3px;
      border-radius: 6px;
    }
  }

  .btn-down {
    position: absolute;
    bottom: 36px;
    left: 50%;
    z-index: 99;
    width: 126px;
    height: 48px;
    margin-left: -63px;
    background-image: url(../../assets/images/btn_down.png);

    animation: toDown 1s infinite;
  }
}

@keyframes toDown {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(0);
  }
}

// page2
.page2 {
  background-image: url(../../assets/images/bg2.jpg);

  .inner-page {
    width: 1224px;
    margin: 0 auto;
    padding-left: 580px;
  }

  .numbers {
    width: 440px;
    height: 54px;
    margin-left: 92px;
    margin-bottom: 20px;
    background-image: url(../../assets/images/p2_number.png);
    background-position: center right;
    background-repeat: no-repeat;

    p {
      width: 168px;
      padding-right: 20px;
      text-align: right;
      color: #ffe2aa;
      font-size: 36px;
    }
  }

  .reached-box {
    width: 536px;
    margin-left: 55px;

    .growth-bar {
      width: 532px;
      height: 24px;
      background-image: url(../../assets/images/growth.png);
    }

    p {
      width: 536px;
      height: 24px;
      background-image: url(../../assets/images/growth2.png);
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
    }
  }

  .reached {
    width: 536px;
    margin-top: -48px;

    img {
      width: 168px;
      height: 223px;
    }
  }
}

.form-box {
  width: 490px;
  height: 565px;
  padding-top: 314px;
  margin-left: 65px;

  .os-box {
    li {
      cursor: pointer;
    }

    .os {
      position: relative;
      display: inline-block;
      width: 24px;
      height: 24px;
      margin-right: 17px;
      border: 1px solid #fff;

      &.active::after {
        position: absolute;
        top: 5px;
        left: 5px;
        z-index: 9;
        width: 12px;
        height: 12px;
        background-color: #fff;
        content: "";
      }
    }

    .gp {
      width: 184px;
      height: 38px;
      background-image: url(../../assets/images/os_gp.png);
    }

    .app {
      width: 154px;
      height: 38px;
      background-image: url(../../assets/images/os_ios.png);
    }
  }

  .input-box {
    position: relative;
    margin-top: 15px;
    margin-bottom: 20px;
    border-bottom: 1px solid #fff;

    span {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 63px;
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      font-family: 'SimHei';
    }

    .input-txt {
      width: 100%;
      height: 44px;
      padding-left: 63px;
      background: transparent;
      color: #fff;
      font-size: 18px;
      line-height: 44px;
      letter-spacing: 2px;
    }
  }

  .check-box {
    margin-bottom: 15px;
    cursor: pointer;

    .check {
      position: relative;
      display: inline-block;
      width: 22px;
      height: 22px;
      margin-right: 12px;
      border: 1px solid #fff;
      vertical-align: -5px;

      &.active::after {
        position: absolute;
        top: 2px;
        left: 2px;
        z-index: 9;
        width: 16px;
        height: 16px;
        background-image: url(../../assets/images/i_checked.png);

        content: "";
      }
    }

    .txt {
      color: #898989;
      font-size: 16px;
      text-decoration: underline;
    }
  }

  .btn-submit {
    display: block;
    width: 442px;
    height: 86px;
    margin-left: 34px;
    background-image: url(../../assets/images/btn_pre2.png);
    -webkit-animation: magnify .8s linear infinite alternate;
    -moz-animation: magnify .8s linear infinite alternate;
    animation: magnify .8s linear infinite alternate;

    .light-effect {
      width: 376px;
      height: 77px;
      margin-left: 34px;
      margin-top: 4px;
      border-radius: 38px;
    }
  }
}

.light-effect {
  position: relative;
  float: left;
  display: inline;
  overflow: hidden;

  .effect {
    position: absolute;
    top: 0;
    left: -100%;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: url(../../assets/images/btn_light.png) no-repeat;
    background-size: 100%;
    transition: all 650ms;
    -webkit-animation: sg 2s linear infinite;
    -moz-animation: sg 2s linear infinite;
    -ms-animation: sg 2s linear infinite;
    animation: sg 2s linear infinite;
  }
}

@keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-webkit-keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-moz-keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-o-keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-webkit-keyframes magnify {
  0% {
    -webkit-transform: scale(0.96);
  }

  100% {
    -webkit-transform: scale(1);
  }
}

@-moz-keyframes magnify {
  0% {
    -moz-transform: scale(1);
  }

  100% {
    -moz-transform: scale(0.96);
  }
}

@keyframes magnify {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.96);
  }
}

// page3
.page3 {
  background-image: url(../../assets/images/bg3.jpg);

  .btn-rule {
    display: block;
    width: 330px;
    height: 58px;
    margin: 954px auto 0;
    background-image: url(../../assets/images/btn_rule.png);

  }
}

// page4
.page4 {
  background-image: url(../../assets/images/bg4.jpg);

  .inner-page {
    width: 1224px;
    margin: 0 auto;
  }

  .lottery-box {
    position: relative;
    width: 497px;
    height: 498px;
    margin-left: 602px;
    margin-top: 345px;

    p {
      position: absolute;
      z-index: 1;

    }

    .l1 {
      top: 0;
      left: 249px;
      width: 236px;
      height: 253px;
      background-image: url(../../assets/images/lottery_1.png);
    }

    .l2 {
      top: 175px;
      right: 0;
      width: 248px;
      height: 276px;
      background-image: url(../../assets/images/lottery_2.png);
    }

    .l3 {
      left: 103px;
      bottom: 1px;
      width: 291px;
      height: 246px;
      background-image: url(../../assets/images/lottery_3.png);
    }

    .l4 {
      left: -2px;
      top: 172px;
      width: 252px;
      height: 280px;
      background-image: url(../../assets/images/lottery_4.png);
    }

    .l5 {
      left: 10px;
      top: -1px;
      width: 240px;
      height: 253px;
      background-image: url(../../assets/images/lottery_5.png);
    }

    .l6 {
      top: 39px;
      left: -1px;
      width: 249px;
      height: 216px;
      background-image: url(../../assets/images/lottery_6.png);
    }

    .btn-lottery {
      position: absolute;
      top: 150px;
      left: 144px;
      z-index: 2;
      width: 204px;
      height: 204px;
      background-image: url(../../assets/images/btn_lottery.png);
      animation: breath 2.5s infinite;
    }
  }
}

// 呼吸效果
@keyframes breath {
  0% {
    transform: scale(.95);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(.95);
  }
}


.page5 {
  position: relative;
  background-image: url(../../assets/images/bg5.jpg);

  .swiper {
    width: 1164px;
    margin-top: 289px;
  }

  .swiper-wrapper {
    margin-left: -182px;
  }

  .swiper-slide {
    width: 752px;
    height: 430px;

    img {
      width: 752px;
      opacity: .5;
    }

    &::after {
      position: absolute;
      top: 5px;
      left: 5px;
      z-index: -1;
      width: 742px;
      height: 420px;
      background-color: #000;
      content: '';
    }
  }

  .swiper-slide-active {
    img {
      opacity: 1;
    }
  }

  button {
    position: absolute;
    top: 186px;
    z-index: 100;
    width: 42px;
    height: 60px;
    background: transparent;
    cursor: pointer;
  }

  .btn-prev {
    left: 100px;
    background-image: url(../../assets/images/btn_prev.png);
  }

  .btn-next {
    right: 100px;
    background-image: url(../../assets/images/btn_next.png);
  }

  .pagination {
    padding-top: 25px;
    text-align: center;
  }

  :deep(.swiper-pagination-bullet) {
    width: 60px;
    height: 3px;
    margin-left: 12px;
    margin-right: 12px;
    background-color: #816842;
    border-radius: 0;
    opacity: 1;

    &.swiper-pagination-bullet-active {
      position: relative;
      width: 120px;
      height: 4px;
      background-color: #d0b88f;
      outline: none;

      &::after {
        position: absolute;
        top: -12px;
        left: 50%;
        margin-left: -6px;
        border: 6px solid transparent;
        border-bottom-color: #d0b88f;
        content: '';
      }
    }
  }

}

.aside {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 100;
  width: 192px;
  height: 590px;
  margin-top: -330px;

  .swiper-slide {
    width: 192px;
    height: 590px;

    &.as1 {
      background-image: url(../../assets/images/nav_bg1.png);
    }

    &.as2 {
      background-image: url(../../assets/images/nav_bg2.png);
    }
  }



  .btn {
    position: absolute;
    left: 18px;
    width: 156px;
    height: 44px;
    z-index: 101;

    &.ios {
      top: 364px;
      background-image: url(../../assets/images/ft_ios.png);
    }

    &.gp {
      top: 314px;
      background-image: url(../../assets/images/ft_gp.png);
    }
    &.naver {
      top: 414px;
      background-image: url(../../assets/images/btn_naver.png);
    }
  }

  .top-ad {
    position: absolute;
    left: 38px;
    top: 462px;
    z-index: 101;
    width: 120px;
    height: 120px;
  }

  .to-top {
    position: absolute;
    bottom: -104px;
    left: 44px;
    z-index: 101;
    width: 104px;
    height: 104px;
    background-image: url(../../assets/images/btn_top.png);
    background-repeat: no-repeat;
  }
}

// 弹窗
.popup-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
  width: 100%;
  background: rgba(0, 0, 0, .8);

  .inner {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 999;
    width: 554px;
    margin-left: -277px;
    background-repeat: no-repeat;
  }

  .btn-close {
    top: -65px;
    left: 506px;
    z-index: 1000;
    margin-left: 0;
  }

  &.popup-login {
    .inner {
      width: 1085px;
      height: 798px;
      margin-left: -644px;
      margin-top: -439px;
      background-image: url(../../assets/images/pop_form.png);
      background-position: bottom center;
    }

    .form-box {
      width: 470px;
      margin-left: 461px;
      padding-top: 493px;
    }

    .btn-submit {
      margin-left: 20px;
    }

    .btn-close {
      left: 920px;
      top: 160px;
    }
  }

  &.popup-success {
    .inner {
      height: 458px;
      margin-top: -229px;
      background-image: url(../../assets/images/pop_suc.jpg);

    }

    .btn-link {
      display: block;
      width: 372px;
      height: 78px;
      margin-left: 90px;
      margin-top: 90px;
      background-image: url(../../assets/images/btn_lounge.png);

    }
  }

  &.popup-rules, &.popup-privacy {
    .inner {
      height: 458px;
      margin-top: -229px;
      background-image: url(../../assets/images/pop_large.jpg);

      h3 {
        text-align: center;
        font-weight: bold;
      }
    }

    .rules, .privacy {
      padding: 54px 50px;
      color: #fff;
      font-size: 18px;
    }
  }

  &.popup-videos {
    .inner {
      width: 800px;
      height: 450px;
      margin-left: -400px;
      margin-top: -225px;
      background-color: #000;
    }

    .btn-close {
      left: 750px;
    }

  }

  &.popup-alert {
    .inner {
      height: 222px;
      margin-top: -111px;
      background-image: url(../../assets/images/pop_s.jpg);

      color: #fff;
      font-size: 18px;
    }

    .text {
      height: 100%;
      padding: 0 30px;
    }
  }

  
  &.popup-again {
    .inner {
      height: 222px;
      margin-top: -111px;
      background-image: url(../../assets/images/pop_s.jpg);

      color: #fff;
      font-size: 18px;
    }

    .text {
      height: 100%;
      padding: 0 30px;
    }
    .btn-link {
      display: block;
      width: 372px;
      height: 78px;
      margin-top: 10px;
      background-image: url(../../assets/images/btn_lounge.png);
      transform: scale(0.8);
    }
  }
}</style>
 